import { useHistory } from "react-router";
import { useMemo, useState } from "react";
import CountUp from "react-countup";
import ButtonsMap from "../../../Components/ComponentsMarketplace/ButtonsMap";

import {
  ExternContainer,
  Container,
  ButtonsFloatContainer,
  ButtonsFloatSection,
  ButtonsFloat,
  ContainerHeader,
  ContainerTitle,
  TotalValue,
  HeaderImg,
  PlayngTime,
  P0,
  P1,
  InfoRodadas,
} from "./style";
import { useUser } from "../../../providers/UserContext";
import { useValue } from "../../../providers/ValueContext";
import useModal from "../../../Components/Modal/hooks/useModal";
import GameModal from "../../../Components/Modal";

const MapMaketplace = () => {
  const history = useHistory();
  const [shedShow, setShedShow] = useState(false);
  const { rodada } = useUser();
  const { entranceValueMarket } = useValue();
  const { close, open, show } = useModal()

  const infosRound = useMemo(() => {
    // Definir as datas de início e fim
    const dataInicio = new Date(rodada?.rodadaInicio);
    const dataFim = new Date(rodada?.rodadaFinal);

    // Calcular a diferença em dias
    const diferenca = Math.ceil((dataFim - dataInicio) / 86400000) + 1;

    // Criar um objeto de data para a data atual
    const dataAtual = new Date().toISOString().substring(0, 10);

    // Calcular o número de dias decorridos
    const diasDecorridos = Math.ceil((new Date(dataAtual) - dataInicio) / 86400000) + 1;

    return {
      totalDias: diferenca,
      dia: diasDecorridos
    }
  }, [rodada])

  const shed = () => setShedShow(!shedShow);

  return (
    <>
      <GameModal
        isMarket={true}
        handleClose={close}
        show={show}
      />
      <ExternContainer>
        <ButtonsFloatContainer>
          <ButtonsFloatSection>
            <ButtonsFloat onClick={() => history.push("/mpPurchasesSausage")}>
              <P0>
                Compras
              </P0>
              <img src="/images/sales_float.svg" alt="Purchases_float" />
            </ButtonsFloat>
            <ButtonsFloat onClick={() => history.push("mpSalesSausage")}>
              <P1>
                Vendas
              </P1>
              <img src="/images/Purchases_float.svg" alt="sales_float" />
            </ButtonsFloat>
          </ButtonsFloatSection>
          <ButtonsFloat onClick={shed}>

            <p>
              Locação:{" "}
              <CountUp
                end={90000}
                separator="."
                decimal=","
                decimals={2}
                duration={0.5}
              />
            </p>

            <img src="/images/shed_float.svg" alt="shed_float" />
          </ButtonsFloat>
          <ButtonsFloatSection>
            <ButtonsFloat onClick={() => history.push("/mpStockSausage")}>
              <P1>
                Estoque
              </P1>
              <img src="/images/stock_float.svg" alt="stock_float" />
            </ButtonsFloat>
            <ButtonsFloat onClick={() => history.push("weeklyReportPurchases")}>
              <P1>
                Relatório semanal
              </P1>
              <img src="/images/calendar_float.svg" alt="calendar_float" />
            </ButtonsFloat>
          </ButtonsFloatSection>
        </ButtonsFloatContainer>

        <Container>
          <ContainerHeader>
            <ContainerTitle>
              <TotalValue>
                <HeaderImg src="./images/cifrao_white.svg" />
                <CountUp
                  end={entranceValueMarket}
                  separator="."
                  decimal=","
                  decimals={2}
                  duration={0.5}
                />
              </TotalValue>

              <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-end',
                width: '100%'
              }}>
                <PlayngTime>
                  <InfoRodadas>
                    {rodada ? (
                      <>
                        <div style={{ display: 'flex' }}>
                          <HeaderImg src="./images/icon_playng_game.svg" />
                          <span>
                            Semana {rodada?.numero}
                          </span>
                        </div>
                        {/* <div style={{ display: 'flex' }}>
                          <HeaderImg src="./images/icon-timer.svg" />
                          <span>
                            Dia {infosRound?.dia} de {infosRound.totalDias}
                          </span>
                        </div> */}
                      </>
                    ) : (
                      <div style={{ display: 'flex' }}>
                        <HeaderImg src="./images/icon_playng_game.svg" />
                        <span>
                          Nenhuma rodada ativa
                        </span>
                      </div>
                    )

                    }
                  </InfoRodadas>
                </PlayngTime>
                <PlayngTime

                  onClick={() => open()}
                >
                  <HeaderImg style={{ width: '36px' }} src="./images/tutorial.svg" />
                  <span >Ajuda</span>
                </PlayngTime>
              </div>
            </ContainerTitle>
            {/* <ContainerButtonTime>
            <TimeButton>
              <img src="./images/button_pause.svg" alt="button_pause" />
            </TimeButton>
            <TimeButton>
              <img src="./images/button_fallow.svg" alt="button_fallow" />
            </TimeButton>
            <TimeButton>
              <img src="./images/button_advance.svg" alt="button_advance" />
            </TimeButton>
          </ContainerButtonTime> */}
            {/* <ImpotEx>
            <ImpExButton>Import</ImpExButton>
            <ImpExButton>Export</ImpExButton>
          </ImpotEx> */}
          </ContainerHeader>

          <ButtonsMap showButtons={false} />
        </Container>
      </ExternContainer>
    </>

  );
};
export default MapMaketplace;
